import React, { useContext, useState } from 'react';
import { IoIosAddCircleOutline } from "react-icons/io";
import { useParams } from 'react-router-dom';
import { BaseURL } from '../../Files/BaseURL';
import { FaFileAlt, FaTimes } from 'react-icons/fa';
import AlertContext from '../../Context/Alert/AlertContext';

const DeclinedBuyerDelivery = ({ btnOffer }) => {
    const { recivedid } = useParams();

    const [Message, setMessage] = useState('');
    const [Files, setFiles] = useState([]);
    const { showAlert } = useContext(AlertContext);

    // Handle file upload and store the file references in state
    const handleFileUpload = (e) => {
        const uploadedFiles = Array.from(e.target.files);
        setFiles((prevFiles) => [...prevFiles, ...uploadedFiles]);
    };

    // Handle file removal
    const removeFile = (index) => {
        setFiles((prevFiles) => prevFiles.filter((_, i) => i !== index));
    };

    const buttonHandler = async () => {
        try {
            const auth = localStorage.getItem('p@token');
            
            // Use FormData to append both text and files
            const formData = new FormData();
            formData.append('OfferId', recivedid);
            formData.append('Message', Message);
            Files.forEach((file) => {
                formData.append('files', file);  // Append each file
            });

            const res = await fetch(`${BaseURL}/api/negotiateOffer/CreateDeclineCase`, {
                method: 'POST',
                headers: {
                    'auth-token': auth
                },
                body: formData  // Send FormData containing OfferId, Message, and files
            });

            if (!res.ok) {
                showAlert('Error sending the negotiation request', 'error');
                return;
            }

            showAlert('Delivery Declined Soon. Paycott will resolve the case sooner', 'success');
            btnOffer('Decline Delivery');
        } catch (error) {
            showAlert('Error Occurred during Declining. Try Again', 'error');
        }
    };

    return (
        <div className='bg-[#FEF8EE] font-pop flex flex-col gap-4 w-full rounded-xl py-4 px-4'>
            <h2 className='text-red-400 text-xl font-semibold'>Decline delivery</h2>
            <div className="bg-white flex flex-col gap-4 w-fit border-[#E9E9E9] border-2 rounded-xl p-2">
                <p className='text-sm text-gray-400'>Case offer</p>
                <p className='text-xl'>#{recivedid}</p>
            </div>
            <div className=" flex flex-col gap-2 p-2">
                <h2>Reason:</h2>
                <input
                    type="text"
                    value={Message}
                    onChange={(e) => setMessage(e.target.value)}
                    placeholder='Reason for decline'
                    className='bg-white py-2 px-2 rounded-lg border-2 border-light'
                />
                <p>Upload any additional information that can help us to understand this case:</p>
                <div className={`flex items-center justify-center w-full bg-white`}>
                    <label
                        htmlFor="dropzone-file"
                        className={`flex flex-col items-center justify-center w-full border-2 border-primarygreen border-dashed rounded-lg bg-white cursor-pointer`}
                    >
                        <div className={`flex flex-row gap-4 items-center justify-center py-3 text-primarygreen font-pop`}>
                            <IoIosAddCircleOutline className="text-2xl" />
                            <p className={`text-base`}>Attach file</p>
                        </div>
                        <input
                            id="dropzone-file"
                            type="file"
                            multiple
                            onChange={handleFileUpload}
                            className="hidden"
                        />
                    </label>
                </div>
                <div className="flex gap-2 flex-wrap">
                    {Files?.map((item, index) => (
                        <div
                            className="border-2 border-primarygreen rounded-lg py-2 px-2 flex gap-1 items-center"
                            key={index}
                        >
                            <FaFileAlt />
                            <p>{item?.name}</p>
                            <FaTimes onClick={() => removeFile(index)} className="cursor-pointer" />
                        </div>
                    ))}
                </div>
            </div>
            <div className="flex gap-2 items-center">
                <button
                    className="my-4 px-2 md:px-6 bg-green-500 hover:bg-transparent hover:bg-white-500 hover:text-black font-pop py-1 md:py-2 border border-black-500 hover:border-green-500 rounded-full text-white"
                    onClick={buttonHandler}
                >
                    Decline
                </button>
                <button
                    className="my-4 px-2 md:px-6 bg-green-500 hover:bg-transparent hover:bg-white-500 hover:text-black font-pop py-1 md:py-2 border border-black-500 hover:border-green-500 rounded-full text-white"
                    onClick={() => { btnOffer('Delivered') }}
                >
                    Retract Declining
                </button>
            </div>
        </div>
    );
};

export default DeclinedBuyerDelivery;
